import type { TPlan } from '@shared/types/plan';

export const dashBoardMockData = {
  dashBoardCards: [
    {
      logo: 'email.png',
      title: 'email',
      value: 23467,
    },
    {
      logo: 'wats.png',
      title: 'whatsApp',
      value: 23467,
    },
    {
      logo: 'sms.png',
      title: 'sms',
      value: 23467,
    },
    {
      logo: 'inApp.png',
      title: 'in App',
      value: 23467,
    },
  ],
  reminderStatistics: [
    {
      type: 'bar-chart',
      title: 'statistics',
      charts: ['2024'],
      data: {
        '2024': {
          series: [
            { data: [35, 44, 24, 34] },
            { data: [51, 6, 49, 30] },
            { data: [15, 25, 30, 50] },
            { data: [60, 50, 15, 25] },
          ],
          xAxis: [{ data: ['Q1', 'Q2', 'Q3', 'Q4'], scaleType: 'band' }],
          height: 299,
          width: 736,
          margin: { top: 10, bottom: 30, left: 40, right: 10 },
        },
      },
    },
    {
      type: 'pie-chart',
      title: 'summary',
      charts: ['whatsApp', 'sms', 'email'],
      data: {
        whatsApp: {
          series: [
            { data: [35, 44, 24, 34] },
            { data: [51, 6, 49, 30] },
            { data: [15, 25, 30, 50] },
            { data: [60, 50, 15, 25] },
          ],
          xAxis: [{ data: ['Q1', 'Q2', 'Q3', 'Q4'], scaleType: 'band' }],
          height: 299,
          width: 736,
          margin: { top: 10, bottom: 30, left: 40, right: 10 },
        },
      },
    },
  ],
};

export const mockedPlansAndPricing: TPlan[] = [
  {
    id: 4,
    title: 'Basic',
    description: 'Individuals or small businesses with basic needs',
    saves: '1,200',
    price: '275',
    yearlyPrice: '229',
    strikePrice: '275',
    bestSeller: false,
    features: {
      users: 3,
      calendlyEvents: 0,
      accounts: 0,
      applications: 150,
      programs: 4,
      programsBand: 'Limited',
      placements: 15,
      leads: '4k',
      invoices: 0,
      tasks: 0,
      onlinePayments: false,
      whatsappMessages: 0,
      smsMessages: undefined,
      emails: '50k',
      appointments: 0,
      bulkReminders: 0,
      storage: '15GB',
      yearsArchiving: 2,
      studentPortalBand: 'Limited',
      remindersMngBand: 'Limited',
      partnersManagementBand: false,
      activityLogs: 3,
      multiOrganization: false,
      integration: undefined,
      managementBand: 'Limited',
      meetings: 0,
    },
  },
  {
    id: 3,
    title: 'Essential',
    description: 'Small to medium-sized businesses with growing requirements',
    price: '479',
    yearlyPrice: '399',
    strikePrice: '479',
    saves: '1,800',
    bestSeller: false,
    features: {
      users: 5,
      accounts: 1,
      applications: 750,
      programs: 8,
      programsBand: 'Basic',
      placements: 50,
      leads: '12k',
      invoices: 840,
      tasks: 'Add-on $599 Annual',
      onlinePayments: true,
      whatsappMessages: '36k',
      smsMessages: undefined,
      emails: '120k',
      appointments: 100,
      bulkReminders: 100,
      storage: '100GB',
      yearsArchiving: 2,
      studentPortalBand: 'Basic',
      remindersMngBand: 'Basic',
      partnersManagementBand: false,
      activityLogs: 10,
      multiOrganization: true,
      integration: 'Basic',
      managementBand: 'Basic',
      meetings: '100',
    },
  },
  {
    id: 2,
    title: 'Advanced',
    description: 'Small to medium-sized businesses with growing requirements',
    bestSeller: true,
    yearlyPrice: '499',
    strikePrice: '599',
    saves: '1,800',
    price: '599',
    features: {
      users: 8,
      accounts: 2,
      applications: 2000,
      programs: 20,
      programsBand: 'Advanced',
      placements: 150,
      leads: '50k',
      invoices: 3600,
      tasks: 'Unlimited Tasks',
      onlinePayments: true,
      whatsappMessages: '60k',
      smsMessages: '24k',
      emails: 'Unlimited',
      appointments: 500,
      bulkReminders: 500,
      storage: '500GB',
      yearsArchiving: 5,
      studentPortalBand: 'Advanced',
      remindersMngBand: 'Advanced',
      partnersManagementBand: true,
      activityLogs: 90,
      multiOrganization: true,
      integration: 'Advanced',
      managementBand: 'Advanced',
      meetings: '500',
    },
  },
  {
    id: 1,
    title: 'Pro',
    description: 'Larger enterprises or users with high-level demands',
    bestSeller: false,
    saves: '5,760',
    yearlyPrice: '999',
    strikePrice: '1,199',
    price: '1,199',
    features: {
      users: 15,
      accounts: 3,
      calendlyEvents: 0,
      applications: 10000,
      programs: 100,
      programsBand: 'Advanced',
      placements: 500,
      leads: '240k',
      invoices: 10000,
      tasks: 'Unlimited Tasks',
      onlinePayments: true,
      whatsappMessages: '240k',
      smsMessages: '60k',
      emails: 'Unlimited',
      appointments: 3000,
      bulkReminders: 2000,
      storage: '1 TB',
      yearsArchiving: 10,
      studentPortalBand: 'Advanced',
      remindersMngBand: 'Advanced',
      partnersManagementBand: true,
      activityLogs: 365,
      multiOrganization: true,
      integration: 'Advanced',
      managementBand: 'Advanced',
      meetings: '3K',
    },
  },
];

export const mockAddonPlansAndPricing = [
  {
    id: 1,
    title: 'Light',
    description: 'Get started with essential capacity for small-scale needs.',
    price: '240',
    features: {
      applications: 20,
      invoices: 20,
      leads: 250,
      appointments: 50,
    },
  },
  {
    id: 2,
    title: 'Plus',
    description: 'A step up with increased limits for growing teams.',
    price: '500',
    features: {
      applications: 50,
      invoices: 50,
      leads: 1000,
      appointments: 100,
    },
  },
  {
    id: 3,
    title: 'Prime',
    description: 'Powerful capacity tailored for growing teams.',
    price: '1000',
    features: {
      applications: 100,
      invoices: 200,
      leads: 3000,
      appointments: 200,
    },
  },
  {
    id: 4,
    title: 'Max',
    description: 'High-capacity add-on designed for scaling businesses.',
    price: '1800',
    features: {
      applications: 200,
      invoices: 200,
      leads: 5000,
      appointments: 500,
    },
  },
  {
    id: 5,
    title: 'Ultra',
    description: 'Maximum limits with priority access.',
    price: '4000',
    features: {
      applications: 500,
      invoices: 500,
      leads: 10000,
      appointments: 2000,
    },
  },
];
